import clx from 'classnames';
import React, { useContext } from 'react';
import ToastMessage from './ToastMessage';
import { ToastContext } from './ToastProvider';

export type ToastContainerProps = {
  variant?: keyof typeof VARIANTS;
};

const VARIANTS = {
  top_left: { style: 'top-4 left-4' },
  top_right: { style: 'top-4 right-4' },
  bottom_right: { style: 'bottom-4 right-4' },
  bottom_left: { style: 'bottom-4 left-4' },
  top_middle: { style: 'top-4 left-1/2 -translate-x-1/2 transform' },
  bottom_middle: { style: 'bottom-4 left-1/2 -translate-x-1/2 transform' },
  undefined: { style: 'top-4 right-4' },
};

export default function ToastContainer({
  variant = 'top_right',
}: ToastContainerProps) {
  const context = useContext(ToastContext);
  const Var = VARIANTS[variant] || VARIANTS.top_right;

  function handleRemove(id: string) {
    context?.remove(id);
  }

  return (
    <div
      className={clx(
        Var.style,
        'fixed z-[100000] flex flex-col gap-2.5 pointer-events-none w-[360px]',
      )}
    >
      {context?.data.map((toast) => (
        <div key={toast.id} className="pointer-events-auto">
          <ToastMessage
            id={toast.id}
            message={toast.message}
            type={toast.type}
            header={toast.header}
            icon={toast.icon}
            truncate={toast.truncate}
            onRemove={handleRemove}
            lifetime={toast.lifetime}
          />
        </div>
      ))}
    </div>
  );
}
